import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTypeComponent } from './document-type.component';
import { AddDocumentTypeComponent } from './add-document-type/add-document-type.component';
import { EditDocumentTypeComponent } from './edit-document-type/edit-document-type.component';

import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [
		DocumentTypeComponent,
		AddDocumentTypeComponent,
		EditDocumentTypeComponent
	],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
	exports: [DocumentTypeComponent],
})
export class DocumentTypeModule { }
